module.exports = __webpack_public_path__ + "static/media/IMG_1563.a1c15d19.JPG";